import React from 'react';
import Button from '../ui/Button';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <section className="contact section" id="contact">
      <div className="container">
        <div className="contact__content">
          <h2 className="contact__title heading-2 text-center">
            Ready to see your organization in one shared view?
          </h2>
          <p className="contact__subtitle text-center">
            Furudio is currently available for a limited number of pilot organizations. 
            If your organization is scaling, navigating change, or ready to build real 
            strategic capability internally, I would love to talk.
          </p>
          <p className="contact__cta-text text-center">
            Book a strategy conversation and let's find out if Furudio is the right fit for you.
          </p>
          <div className="contact__actions">
            <Button
              variant="primary"
              size="lg"
              onClick={() => window.location.href = 'mailto:info@furudio.com?subject=Strategy%20Conversation'}
            >
              info@furudio.com
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
